import { IAutomationObject } from "../../types";

export const schema = 'AutomationApps.Functions.Calendar.Calendar';
export const modelId = 'dtmi:AutomationApps:Functions:Calendar:Calendar';

export interface ICalendarDictionary {
    [index: string]: string;
}

export interface ICalendar extends IAutomationObject {
    //dateList: string,
    isOn: boolean,
    dates: ICalendarDictionary,
    dateRanges: ICalendarDictionary,
    weekNDays: ICalendarDictionary,
}

export interface ICalenderDateListDto {
    dates: FlexDateDto[],
    dateRanges: FlexDateRangeDto[],
    weekNDays: FlexWeekNDayDto[],
}

export type CalenderDateListDto = {
    dates: FlexDateDto[],
    dateRanges: FlexDateRangeDto[],
    weekNDays: FlexWeekNDayDto[],
}

export type FlexDateDto = {
    year: number,
    month: number,
    day: number,
    wday: number,
    kind: 'FlexDateDto'
}

export type FlexDateRangeDto =  {
    start: FlexDateDto,
    end: FlexDateDto,
    kind: 'FlexDateRangeDto'
}

export type FlexWeekNDayDto = {
    weekDay: number,
    month: number,
    week: number,
    kind: 'FlexWeekNDayDto'
}


// ui model
export type FlexDateRange = {
    start: FlexDate,
    end: FlexDate,
}

export type FlexDate = {
    date: Date,
    flexYear: boolean,
    flexMonth: boolean,
    evenMonths: boolean,
    oddMonths: boolean,
    flexDay: boolean,
}
